import currency from"currency.js";var roundValue=function(value,currencyPrecision){return currency(value,{symbol:"",precision:currencyPrecision}).value};export default roundValue;
//# sourceMappingURL=roundValue.js.map